import { ApiErrors } from "../api.errors";

type ApiError = (typeof ApiErrors)[keyof typeof ApiErrors];

export const findErrorByCode = (errorCode: number): ApiError | null => {
  return Object.values(ApiErrors).find((error) => error.errorCode === errorCode) || null;
};
